export const TOGGLE_ASSET_TRANSACTION_SLIDEUP = "TOGGLE_ASSET_TRANSACTION_SLIDEUP";